import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/helper';
import {
  clearSaleCustomer,
  selectSaleCustomer,
  setSaleCustomer,
  type SaleCustomer,
} from '../redux/cartSlice';
import { AppSnackbar } from '../services/AppSnackbar';

/** The customer attached to the sale being built in the cart. */
export const useSaleCustomer = () => {
  const dispatch = useAppDispatch();
  const customer = useAppSelector(selectSaleCustomer);

  const setCustomer = useCallback(
    (next: SaleCustomer | null) => {
      dispatch(setSaleCustomer(next));
    },
    [dispatch],
  );

  /** Takes the customer off the sale, with Undo in the message. */
  const removeCustomer = useCallback(() => {
    if (!customer) return;
    const removed = customer;
    dispatch(clearSaleCustomer());
    AppSnackbar.show(`${removed.name} removed from this sale`, 'success', {
      actionLabel: 'UNDO',
      onAction: () => dispatch(setSaleCustomer(removed)),
    });
  }, [customer, dispatch]);

  return { customer, setCustomer, removeCustomer };
};

export default useSaleCustomer;
